export default {
  title: 'Modifier le mot de passe',
  form: {
    email: {
      label: 'E-mail',
      placeholder: "Saisir l'e-mail",
    },
    new_password: {
      label: 'Nouveau mot de passe',
      placeholder: 'Saisir le mot de passe',
      requirements: 'Votre mot de passe doit contenir 8 caractères, une majuscule et un chiffre',
    },
    confirm_password: {
      label: 'Confirmation du nouveau mot de passe',
      placeholder: 'Confirmer le mot de passe',
    },
    error_messages: {
      missing_info: 'Informations manquantes',
    },
  },
  buttons: {
    change_password: 'Modifier le mot de passe',
  },
};
